module.exports = __webpack_public_path__ + "img/6.20631a1e.png";